import React, { useState, useEffect } from 'react';

export default function SessionExpiredModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleSessionExpiredEvent = () => {
      setIsOpen(true);
    };

    window.addEventListener('sessionExpired', handleSessionExpiredEvent);

    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpiredEvent);
    };
  }, []);

  if (!isOpen) return null;

  const handleClose = () => {
    setIsOpen(false);
    window.location.href = '/login';
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white p-8 rounded-lg shadow-2xl max-w-sm w-full mx-auto relative animate-in fade-in zoom-in duration-200">
        <h2 className="text-2xl font-serif italic mb-3 text-slate-900">Sesión Expirada</h2>
        <p className="text-slate-600 mb-8 font-light leading-relaxed">
          Tu sesión ha expirado por inactividad. Por favor, inicia sesión nuevamente para continuar trabajando.
        </p>
        <div className="flex justify-end">
          <button 
            onClick={handleClose}
            className="bg-slate-900 hover:bg-slate-800 text-white font-light uppercase tracking-widest text-xs py-3 px-6 rounded transition-colors w-full"
          >
            Ir al Login
          </button>
        </div>
      </div>
    </div>
  );
}